import React from 'react';
import { LinearProgress } from '@mui/material';
import './PageLoader.css';

function PageLoader() {
  return (
    <div className="page-loader-container">
      <div className="page-loader-content">
        <h4 className="page-loader-name">
          Jérôme Jouanny
        </h4>
        <LinearProgress className="page-loader-progress" />
      </div>
    </div>
  );
}

export default PageLoader;
